const baseUrl = import.meta.env.BASE_URL || '/';

export const APP_BASE_PATH = baseUrl.replace(/\/$/, '') || '/';

export const withAppBasePath = (pathname: string): string => {
  if (APP_BASE_PATH === '/') {
    return pathname;
  }

  return `${APP_BASE_PATH}${pathname.startsWith('/') ? pathname : `/${pathname}`}`;
};
